<template>
  <div class="laddercontrol">
    <div class="header">
      <div class="title">多种乘梯方式 生活更便捷</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div class="item" v-for="item in laddercontrol" :key="item.id">
          <img :src="item.logo" alt="" />
          <div>{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobileladdercontrol1 from "../../../../assets/programme/mobileladdercontrol1.png";
import mobileladdercontrol2 from "../../../../assets/programme/mobileladdercontrol2.png";
import mobileladdercontrol3 from "../../../../assets/programme/mobileladdercontrol3.png";
import mobileladdercontrol4 from "../../../../assets/programme/mobileladdercontrol4.png";
import mobileladdercontrol5 from "../../../../assets/programme/mobileladdercontrol5.png";
import mobileladdercontrol6 from "../../../../assets/programme/mobileladdercontrol6.png";

export default {
  setup() {
    return reactive({
      laddercontrol: [
        {
          id: 1,
          title: "刷卡乘梯",
          logo: mobileladdercontrol1,
        },
        {
          id: 2,
          title: "人脸识别乘梯",
          logo: mobileladdercontrol2,
        },
        {
          id: 3,
          title: "一键分享访客乘梯",
          logo: mobileladdercontrol3,
        },
        {
          id: 4,
          title: "预约乘梯",
          logo: mobileladdercontrol4,
        },
        {
          id: 5,
          title: "自动呼梯",
          logo: mobileladdercontrol5,
        },
        {
          id: 6,
          title: "欠费停梯",
          logo: mobileladdercontrol6,
        },
      ],
    });
  },
};
</script>

<style scoped>
.laddercontrol {
  width: 92vw;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  margin-top: 16px;
}

.body .list {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}

.body .list .item {
  position: relative;
  overflow: hidden;
  margin-bottom: 15px;
}
.body .list .item img {
  width: 164px;
}

.body .list .item div {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  font-size: 16px;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.2);
  padding: 16px 0;
  backdrop-filter: blur(20px);
}
</style>
